export default __webpack_public_path__ + "static/media/NIAS0560.34I-40204_-23872_0.cb2a960e.jpg";